export default __webpack_public_path__ + "static/media/add_button.8f8d7286.svg";